export default "__VITE_ASSET__96438c63__"